import { useState, useCallback } from 'react';
import { listarCarga } from '../services/servicesCargaValidacion';
import { ListaCargaValidadorDTO, ResultadoCargaArchivo } from '../models/cargaValidacion';
import { ErrorCarga } from '../../comun/components/models/comunModels';

function useCargarValidacion() {
    const [error, setError] = useState<ErrorCarga[]>([]);
    const [data, setData] = useState<ListaCargaValidadorDTO[]>([]);
    const [archivoTxt, setArchivoTxt] = useState<string>();

    const listar = useCallback(async (data: File) => {
        setError([]);
        setData([]);

        const respuesta = await listarCarga(data);
        if (respuesta.status !== 200)
            return;

        const resultado: ResultadoCargaArchivo = respuesta.data;
        setData(resultado.registrosValidos);
        setArchivoTxt(resultado.archivoTXT);

        if (resultado.tieneErrores)
            setError(resultado.errores);

    }, []);

    const limpiar = useCallback(() => {
        setError([]);
        setData([]);
        setArchivoTxt('');
    }, []);

    return { data, error, listar, archivoTxt, limpiar };
}

export default useCargarValidacion;